/** Auth contracts (docs/03-Backend/Authentication.md). */
export const STAFF_TWO_FACTOR_POLICIES = ['off', 'optional', 'required'];
export function isTwoFactorChallenge(result) {
    return 'twoFactor' in result;
}
export const SOCIAL_PROVIDERS = ['google', 'apple'];
//# sourceMappingURL=auth.js.map